import * as React from 'react';
import { Ref } from 'react-hook-form';

import './index.scss';

interface IProps {
    name: string;
    options: IOption[];
    register: Ref;
}

interface IOption {
    value: any;
    text: string;
}

export const SelectInput: React.SFC<IProps> = ({ name, options, register }) => {
    return (
        <div className="select-box">
            <select
                className="select-style"
                name={name}
                ref={register}
            >
                {options && options.map((option) => (
                    <option value={option.value} key={option.value}>
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
    );
};
